import { forwardRef } from 'react';

import Box from 'shared_DEPRECATED/components/Box';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import { USER_MODES } from 'features/user/config';
import { useUserMode } from 'features/user/hooks';
import { useCurrentModeUser } from 'features/user/hooks/useCurrentModeUser';

import { Typography } from 'shared/components/Typography';

type TChatMessageSystem = {
  text: string;
};

export const ChatMessageSystem = forwardRef<HTMLDivElement, TChatMessageSystem>(
  ({ text }, ref) => {
    const user = useCurrentModeUser();
    const userMode = useUserMode();
    const isParticipantMode = userMode === USER_MODES.dashboard;
    const parsedText = isParticipantMode
      ? text.replace(user.name, 'You').replace('has', 'have')
      : text;

    return (
      <Box
        style={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box
          style={{
            position: 'absolute',
            top: '50%',
            bottom: '50%',
            left: 0,
            right: 0,
            height: '1px',
          }}
        />
        <Box
          style={{
            position: 'relative',
            zIndex: 1,
          }}
        >
          <Spacer size="md">
            <Typography type="meta" color="gray" textAlign="center">
              {parsedText}
            </Typography>
          </Spacer>
          <div ref={ref} />
        </Box>
      </Box>
    );
  }
);
